"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _inputSizes = _interopRequireDefault(require("./inputSizes.css"));

var _inputStates = _interopRequireDefault(require("./inputStates.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: .8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-bottom: 2px solid ", ";\n  border-radius: 4px;\n  &::placeholder {\n    color: ", ";\n  }\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Textarea = _styledComponents["default"].textarea(_templateObject(), function (props) {
  return props.width || '100%';
}, function (props) {
  return props.theme.colors.white['300'];
}, function (props) {
  return props.theme.colors.white['300'];
}, function (props) {
  return props.theme.colors.gray['900'];
}, _inputStates["default"], _inputSizes["default"]);

var _default = Textarea;
exports["default"] = _default;